const DEBOUNCE_MS = 250;

type FlushFn = () => void;

const flushers = new Set<FlushFn>();
let listenersRegistered = false;

function registerFlushListeners(): void {
  if (listenersRegistered || typeof window === "undefined") return;
  listenersRegistered = true;

  const flushAll = () => {
    flushers.forEach((fn) => fn());
  };

  window.addEventListener("beforeunload", flushAll);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      flushAll();
    }
  });
}

/**
 * Returns a debounced writer and a flush function for immediate persist.
 */
export function createDebouncedSave<T>(write: (value: T) => void) {
  let pending: T | null = null;
  let timer: ReturnType<typeof setTimeout> | null = null;

  const flush = () => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
    if (pending !== null) {
      write(pending);
      pending = null;
    }
  };

  const schedule = (value: T) => {
    pending = value;
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(flush, DEBOUNCE_MS);
  };

  registerFlushListeners();
  flushers.add(flush);

  return { schedule, flush };
}
